import { useEffect, useState } from "react";
import {
  decodeDataToken,
  decodeRefreshToken,
  getToken,
} from "../../../../../helpers/token/refreshToken";
import { getEnterpriseEmployeeAddress } from "../../../../../api/users/enterprise/address/address";
import { getEnterpriseData } from "../../../../../api/users/enterprise/data/enterprise";

export const useEnterpriseBookingAddresses = () => {
  const [addressApi, setAddressApi] = useState([]);
  const [addressOrigin, setAddressOrigin] = useState(null);
  const [paymentType, setPaymentType] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadEnterpriseBookingAddresses = async () => {
      try {
        const token = getToken("etknre");
        const dataToken = getToken("dttkn");

        if (dataToken !== null && token !== null) {
          const { enterprise_id } = decodeDataToken(dataToken);
          const uid = decodeRefreshToken(token);

          if (!isMounted) return;
          setAddressApi([]);
          setAddressOrigin(null);

          const response = await getEnterpriseEmployeeAddress(
            token,
            uid,
            enterprise_id,
          );

          if (!isMounted) return;
          setAddressApi(response.data);

          const resPaymentType = await getEnterpriseData("", enterprise_id);

          if (!isMounted) return;
          setPaymentType(resPaymentType.data[0].payment_type);
        } else {
          console.log("no ingreso a esa validacion");
        }
      } catch (error) {
        console.log(error);
      }
    };

    loadEnterpriseBookingAddresses();

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    addressApi,
    addressOrigin,
    setAddressOrigin,
    paymentType,
  };
};
